  // import { useState, useEffect } from "react";
  // import { Container, Table, Button, Modal, Form, Spinner } from "react-bootstrap";
  // import { motion } from "framer-motion";
  // import { FaEdit, FaTrash } from "react-icons/fa";
  // import Header from "../../component/header/header";
  // import Sidebar from "../../component/sidebar/sidebar";
  // import api from "../../api/axios";

  // const emptyProduct = {
  //   name: "",
  //   category: "",
  //   price: "",
  //   images: null,
  // };

  // const Product = () => {
  //   const [products, setProducts] = useState([]);
  //   const [loading, setLoading] = useState(true);
  //   const [show, setShow] = useState(false);
  //   const [editData, setEditData] = useState(null);
  //   const [isEdit, setIsEdit] = useState(false);

  //   // FETCH PRODUCTS
  //   useEffect(() => {
  //     const fetchProducts = async () => {
  //       try {
  //         const res = await api.get("/products");
  //         setProducts(res.data);
  //       } catch (err) {
  //         console.error("Failed to fetch products:", err.response?.data || err.message);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchProducts();
  //   }, []);

  //   // DELETE
  //   const handleDelete = async (id) => {
  //     try {
  //       await api.delete(`/products/${id}`);
  //       setProducts(products.filter((item) => item._id !== id));
  //     } catch (err) {
  //       console.error("Delete failed:", err.response?.data || err.message);
  //     }
  //   };

  //   // OPEN EDIT
  //   const handleEdit = (product) => {
  //     setEditData({ ...product, images: null });
  //     setIsEdit(true);
  //     setShow(true);
  //   };

  //   // OPEN ADD
  //   const handleAdd = () => {
  //     setEditData(emptyProduct);
  //     setIsEdit(false);
  //     setShow(true);
  //   };

  //   // SAVE PRODUCT (ADD / EDIT)
  //   const handleSave = async () => {
  //     try {
  //       const formData = new FormData();

  //       formData.append("name", editData.name);
  //       formData.append("category", editData.category);
  //       formData.append("price", editData.price);
  //       formData.append("description", editData.description);

  //       if (editData.images && editData.images.length > 0) {
  //         Array.from(editData.images).forEach((file) => {
  //           formData.append("images", file);
  //         });
  //       }

  //       let res;

  //       if (isEdit) {
  //         res = await api.put(`/products/${editData._id}`, formData);
  //         setProducts(products.map((item) =>
  //           item._id === res.data._id ? res.data : item
  //         ));
  //       } else {
  //         res = await api.post("/products", formData);
  //         setProducts([...products, res.data]);
  //       }

  //       setShow(false);
  //     } catch (err) {
  //       console.error("Save failed:", err.response?.data || err.message);
  //     }
  //   };

  //   if (loading) return <Spinner animation="border" />;

  //   return (
  //     <>
  //       <Header />
  //       <Sidebar />

  //       <main className="admin-content">
  //         <Container fluid>
  //           <motion.h4
  //             initial={{ opacity: 0, y: 10 }}
  //             animate={{ opacity: 1, y: 0 }}
  //             className="mb-4"
  //           >
  //             Products
  //           </motion.h4>

  //           <Button className="mb-3" onClick={handleAdd}>
  //             + Add Product
  //           </Button>

  //           <motion.div
  //             initial={{ opacity: 0, y: 30 }}
  //             animate={{ opacity: 1, y: 0 }}
  //             className="table-wrapper"
  //           >
  //             <Table responsive bordered hover>
  //               <thead>
  //                 <tr>
  //                   <th>Name</th>
  //                   <th>Category</th>
  //                   <th>Price</th>
  //                   <th>Actions</th>
  //                 </tr>
  //               </thead>

  //               <tbody>
  //                 {products.map((item, index) => (
  //                   <motion.tr key={item._id} transition={{ delay: index * 0.05 }}>
  //                     <td>{item.name}</td>
  //                     <td>{item.category}</td>
  //                     <td>{item.price}</td>

  //                     <td>
  //                       <Button size="sm" onClick={() => handleEdit(item)}>
  //                         <FaEdit />
  //                       </Button>{" "}
  //                       <Button size="sm" variant="danger" onClick={() => handleDelete(item._id)}>
  //                         <FaTrash />
  //                       </Button>
  //                     </td>
  //                   </motion.tr>
  //                 ))}
  //               </tbody>
  //             </Table>
  //           </motion.div>
  //         </Container>
  //       </main>

  //       {/* MODAL */}
  //       <Modal show={show} onHide={() => setShow(false)} centered>
  //         <Modal.Header closeButton>
  //           <Modal.Title>{isEdit ? "Edit Product" : "Add Product"}</Modal.Title>
  //         </Modal.Header>

  //         {editData && (
  //           <Modal.Body>
  //             <Form>
  //               <Form.Group className="mb-3">
  //                 <Form.Label>Name</Form.Label>
  //                 <Form.Control
  //                   value={editData.name}
  //                   onChange={(e) => setEditData({ ...editData, name: e.target.value })}
  //                 />
  //               </Form.Group>

  //               <Form.Group className="mb-3">
  //                 <Form.Label>Category</Form.Label>
  //                 <Form.Control
  //                   value={editData.category}
  //                   onChange={(e) =>
  //                     setEditData({ ...editData, category: e.target.value })
  //                   }
  //                 />
  //               </Form.Group>

  //               <Form.Group className="mb-3">
  //                 <Form.Label>Price</Form.Label>
  //                 <Form.Control
  //                   value={editData.price}
  //                   onChange={(e) =>
  //                     setEditData({ ...editData, price: e.target.value })
  //                   }
  //                 />
  //               </Form.Group>

  //               {/* IMAGE INPUT (IMPORTANT) */}
  //               <Form.Group className="mb-3">
  //                 <Form.Label>Product Images</Form.Label>
  //                 <Form.Control
  //                   type="file"
  //                   name="images"
  //                   multiple
  //                   accept="image/*"
  //                   onChange={(e) =>
  //                     setEditData({ ...editData, images: e.target.files })
  //                   }
  //                 />
  //               </Form.Group>
  //             </Form>
  //           </Modal.Body>
  //         )}

  //         <Modal.Footer>
  //           <Button variant="secondary" onClick={() => setShow(false)}>
  //             Cancel
  //           </Button>
  //           <Button variant="primary" onClick={handleSave}>
  //             Save
  //           </Button>
  //         </Modal.Footer>
  //       </Modal>
  //     </>
  //   );
  // };

  // export default Product;
  import { useState, useEffect } from "react";
  import { Container, Table, Button, Modal, Form, Spinner } from "react-bootstrap";
  import { motion } from "framer-motion";
  import { FaEdit, FaTrash } from "react-icons/fa";
  import Header from "../../component/header/header";
  import Sidebar from "../../component/sidebar/sidebar";
  import api from "../../api/axios";

  // Include description in emptyProduct
  const emptyProduct = {
    name: "",
    category: "",
    price: "",
    description: "", // NEW FIELD
    images: null,
  };

  const Product = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [editData, setEditData] = useState(null);
    const [isEdit, setIsEdit] = useState(false);

    // FETCH PRODUCTS
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const res = await api.get("/products");
          setProducts(res.data);
        } catch (err) {
          console.error("Failed to fetch products:", err.response?.data || err.message);
        } finally {
          setLoading(false);
        }
      };
      fetchProducts();
    }, []);

    // DELETE
    const handleDelete = async (id) => {
      try {
        await api.delete(`/products/${id}`);
        setProducts(products.filter((item) => item._id !== id));
      } catch (err) {
        console.error("Delete failed:", err.response?.data || err.message);
      }
    };

    // OPEN EDIT
    const handleEdit = (product) => {
      setEditData({ ...product, images: null });
      setIsEdit(true);
      setShow(true);
    };

    // OPEN ADD
    const handleAdd = () => {
      setEditData(emptyProduct);
      setIsEdit(false);
      setShow(true);
    };

    // SAVE PRODUCT (ADD / EDIT)
    const handleSave = async () => {
      try {
        const formData = new FormData();

        formData.append("name", editData.name);
        formData.append("category", editData.category);
        formData.append("price", editData.price);
        formData.append("description", editData.description); // NEW FIELD

        if (editData.images && editData.images.length > 0) {
          Array.from(editData.images).forEach((file) => {
            formData.append("images", file);
          });
        }

        let res;

        if (isEdit) {
          res = await api.put(`/products/${editData._id}`, formData);
          setProducts(
            products.map((item) => (item._id === res.data._id ? res.data : item))
          );
        } else {
          res = await api.post("/products", formData);
          setProducts([...products, res.data]);
        }

        setShow(false);
      } catch (err) {
        console.error("Save failed:", err.response?.data || err.message);
      }
    };

    if (loading) return <Spinner animation="border" />;

    return (
      <>
        <Header />
        <Sidebar />

        <main className="admin-content">
          <Container fluid>
            <motion.h4
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-4"
            >
              Products
            </motion.h4>

            <Button className="mb-3" onClick={handleAdd}>
              + Add Product
            </Button>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              className="table-wrapper"
            >
              <Table responsive bordered hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Price</th>
                    <th>Description</th> {/* NEW COLUMN */}
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {products.map((item, index) => (
                    <motion.tr key={item._id} transition={{ delay: index * 0.05 }}>
                      <td>{item.name}</td>
                      <td>{item.category}</td>
                      <td>{item.price}</td>
                      <td>{item.description || "-"}</td> {/* SHOW DESCRIPTION */}
                      <td>
                        <Button size="sm" onClick={() => handleEdit(item)}>
                          <FaEdit />
                        </Button>{" "}
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() => handleDelete(item._id)}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </Table>
            </motion.div>
          </Container>
        </main>

        {/* MODAL */}
        <Modal show={show} onHide={() => setShow(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEdit ? "Edit Product" : "Add Product"}</Modal.Title>
          </Modal.Header>

          {editData && (
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    value={editData.name}
                    onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Category</Form.Label>
                  <Form.Control
                    value={editData.category}
                    onChange={(e) =>
                      setEditData({ ...editData, category: e.target.value })
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    value={editData.price}
                    onChange={(e) =>
                      setEditData({ ...editData, price: e.target.value })
                    }
                  />
                </Form.Group>

                {/* NEW DESCRIPTION FIELD */}
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={editData.description}
                    onChange={(e) =>
                      setEditData({ ...editData, description: e.target.value })
                    }
                  />
                </Form.Group>

                {/* IMAGE INPUT */}
                <Form.Group className="mb-3">
                  <Form.Label>Product Images</Form.Label>
                  <Form.Control
                    type="file"
                    name="images"
                    multiple
                    accept="image/*"
                    onChange={(e) =>
                      setEditData({ ...editData, images: e.target.files })
                    }
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
          )}

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  export default Product;
